import { API_URL, jwtToken } from "../../../context/appContext";
export default async function clearBotStatus(id) {
    return fetch(`${API_URL}/api/bot_status/${id}`, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
